import { debounce } from 'lodash';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { SEARCH_DEBOUNCE_MS } from '~/common/constants/debounces';
import { FormField } from '~/eds/src/components/FormField/FormField';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { TextArea } from '~/eds/src/components/TextArea/TextArea';
import { Filter } from '~/evifields/src/types/Filter';
import { TextValue } from '~/evifields/src/types/Value';
import { api } from '~/redux/api/createApi';
import { Nullable } from '~/types/Nullable';

interface Props {
  filter: Filter<TextValue>;
  onChange: (_updatedValues: TextValue[]) => void;
}

export const BooleanTextValue = ({ filter, onChange }: Props): JSX.Element => {
  const intl = useIntl();
  const { values } = filter;
  const [value = ''] = values;
  const [validateBooleanQuery, { data }] =
    api.endpoints.validateBooleanQuery.useLazyQuery();

  const debouncedValidate = useCallback(
    debounce((query) => {
      validateBooleanQuery(query);
    }, SEARCH_DEBOUNCE_MS),
    [validateBooleanQuery],
  );

  const handleChange = (updatedValue: Nullable<string>) => {
    onChange(updatedValue ? [updatedValue] : []);
    debouncedValidate(updatedValue);
  };

  return (
    <Layout w={250} maxW={250} direction="column">
      <FormField<string, false>
        label=""
        input={TextArea}
        error={data?.detail ? data.detail : undefined}
        name="boolean-text-search"
        placeholder={intl.formatMessage({
          id: 'BooleanTextValue.searchPlaceholder',
          defaultMessage: 'Boolean text search',
          description: 'Placeholder text for boolean text search input',
        })}
        value={value}
        onChange={handleChange}
      />
    </Layout>
  );
};
